import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {WithdrawalAmountInputMode} from '@gatewee/utils';
import {TranslateModule} from '@ngx-translate/core';

export type AmountFeeBreakdownVariant = 'compact' | 'detailed';

@Component({
  selector: 'gatewee-amount-fee-breakdown',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './gatewee-amount-fee-breakdown.component.html',
  styleUrls: ['./gatewee-amount-fee-breakdown.component.css'],
})
export class GateweeAmountFeeBreakdownComponent {
  @Input() amount: number | null = null;
  @Input() calculatedFee: number | null = null;
  @Input() finalAmount: number | null = null;
  @Input() variant: AmountFeeBreakdownVariant = 'detailed';
  @Input() inputMode: WithdrawalAmountInputMode | null = null;

  get hasFee(): boolean {
    return (this.calculatedFee ?? 0) > 0;
  }

  get resolvedFinalAmount(): number | null {
    if (this.finalAmount !== null && this.finalAmount !== undefined) {
      return this.finalAmount;
    }
    if (this.amount === null || this.amount === undefined) {
      return null;
    }
    return Math.max(0, this.amount - (this.calculatedFee ?? 0));
  }

  get showBreakdown(): boolean {
    return (
      this.amount !== null &&
      this.amount !== undefined &&
      this.resolvedFinalAmount !== null
    );
  }

  /** User-typed amount: net payout in addFees, wallet debit in deductFees / post-create. */
  get enteredAmount(): number | null {
    if (this.inputMode === 'addFees') {
      return this.resolvedFinalAmount;
    }
    return this.amount;
  }

  get isAddFeesMode(): boolean {
    return this.inputMode === 'addFees';
  }

  get feePrefix(): string {
    return this.isAddFeesMode ? '+' : '−';
  }

  get compactHeroAmount(): number | null {
    return this.resolvedFinalAmount;
  }

  get detailedEmphasisLabelKey(): string {
    return this.isAddFeesMode
      ? 'common.paymentReceipt.amountBreakdown.walletDebit'
      : 'common.paymentReceipt.amountBreakdown.recipientReceives';
  }

  get detailedEmphasisAmount(): number | null {
    return this.isAddFeesMode ? this.amount : this.resolvedFinalAmount;
  }
}
